import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import DXSelectFilter from '../DXSelectFilter/DXSelectFilter';
import DXFilterConfig from '../DXFilterConfig';
import constants from '../../constants';

const propTypes = {
  equality: PropTypes.string,
  selected: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  selected: [],
};

class DXHathImageFilter extends React.Component {
  render() {
    const { selected, onChange, intl, equality } = this.props;
    const config = DXHathImageFilter.getConfig(intl, equality);
    return (
      <DXSelectFilter
        selected={selected}
        title={config.title}
        values={config.values}
        onChange={onChange}
        multi={config.multi}
      />
    );
  }
}

DXHathImageFilter.propTypes = propTypes;
DXHathImageFilter.defaultProps = defaultProps;
DXHathImageFilter.getLabel = (intl, selectedValues) => {
  return DXSelectFilter.getLabel(intl, 'filter.hasImage.', selectedValues);
};
DXHathImageFilter.applyToQueryParams = (queryParams, selectedValues) => {
  selectedValues[0] && (queryParams['image'] = selectedValues[0]);
  return queryParams;
};
DXHathImageFilter.getConfig = (intl, equality) => {
  let config = new DXFilterConfig({
    name: 'hasImage',
    selected: [],
    property: 'image',
    title: intl.formatMessage({ id: 'filter.hasImage.title' }),
    disabled: false,
    equalityStatus: false,
    multi: false,
  });

  if (equality === constants.FILTER_EQUALITY_EQUALS) {
    config.addFilterValue('true', intl.formatMessage({ id: 'filter.hasImage.true' }));
    config.addFilterValue('false', intl.formatMessage({ id: 'filter.hasImage.false' }));
  }

  return config;
};

DXHathImageFilter.getInitialConfig = (intl, values, readOnly, invisible) => {
  return {
    name: 'hasImage',
    title: intl.formatMessage({ id: 'filter.hasImage.title' }),
    property: 'image',
    type: 'hasImage',
    selectedValues: values,
    clientSide: false,
    readOnly: readOnly ? readOnly : false,
    fromVariable: !!invisible || false,
  };
};

export default injectIntl(DXHathImageFilter);
